/* eslint no-console:0 */
let componentsRequireContext = require.context("components", true);
let ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentsRequireContext);
